import { render, staticRenderFns } from "./DSSearchIcon.vue?vue&type=template&id=20226a1e&scoped=true&"
import script from "./DSSearchIcon.vue?vue&type=script&lang=js&"
export * from "./DSSearchIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20226a1e",
  null
  
)

export default component.exports